/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-07-10 20:11:22 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-11-12 04:17:01
 */

import { Injectable } from "@angular/core";

import { ENV } from '../env/env';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import tus from 'tus-js-client';
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';

import { Platform } from "ionic-angular";
import { TransService } from "./trans.service";
import { PhotoLibrary } from "@ionic-native/photo-library";
@Injectable()
export class VideoService {

  private urlVimeo = 'https://api.vimeo.com/me/videos';

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/videos`;

  constructor(
    private photoLibrary: PhotoLibrary,
    private transService: TransService,
    private http: HttpClient,
    private transfer: FileTransfer,
    private file: File,
    public platform: Platform,
  ) {
  }

  createVideo(uri) {
    return this.http.post(`${this.url}?lang=${this.transService.lang}`, {
      uri
    });
  }

  uploadVideo(file: any, title, callback: any) {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${ENV.VIMEO_TOKEN}`,
      'Content-Type': 'application/json',
      'Accept': 'application/vnd.vimeo.*+json;version=3.4',
    });
    return this.http.post(this.urlVimeo, {
      "upload": {
        "approach": "tus",
        "size": file.size
      },
      "name": title
    }, {
      headers: headers,
      })
      .subscribe(res => {
        // const uri = res['uri'];
        const upload_link = res['upload']['upload_link'];
        const link = res['link'];

        callback({
          name: 'onReady',
        });
        
        let upload = new tus.Upload(file, {
          endpoint: 'none',
          retryDelays: [0, 1000, 3000, 5000],
          uploadSize: file.size,
          onError: (error) => {
            callback({
              name: 'onError',
              error: error,
            });
          },
          onProgress: (bytesUploaded, bytesTotal) => {
            callback({
              name: 'onProgress',
              bytesUploaded: bytesUploaded,
              bytesTotal: bytesTotal,
            });
          },
          onSuccess: () => {
            callback({
              name: 'onSuccess',
              link: link
            });
          }
        })
        upload.url = upload_link;
        upload.start()
      })
  }

  // uploadVideoByBlob(blob: Blob, fileSize, callback: any) {
  //   const headers = new HttpHeaders({
  //     'Authorization': `bearer ${ENV.VIMEO_TOKEN}`,
  //     'Content-Type': 'application/json',
  //     'Accept': 'application/vnd.vimeo.*+json;version=3.4',
  //   });
  //   return this.http.post(this.urlVimeo, {
  //     "upload": {
  //       "approach": "tus",
  //       "size": fileSize
  //     },
  //   }, {
  //       headers: headers,
  //     })
  //     .subscribe(res => {
  //       const upload_link = res['upload']['upload_link'];
  //       const link = res['link'];

  //       callback({
  //         name: 'onReady',
  //       });

  //       let upload = new tus.Upload(blob, {
  //         endpoint: 'none',
  //         retryDelays: [0, 1000, 3000, 5000],
  //         uploadSize: fileSize,
  //         onError: (error) => {
  //           callback({
  //             name: 'onError',
  //             error: error,
  //           });
  //         },
  //         onProgress: (bytesUploaded, bytesTotal) => {
  //           callback({
  //             name: 'onProgress',
  //             bytesUploaded: bytesUploaded,
  //             bytesTotal: bytesTotal,
  //           });
  //         },
  //         onSuccess: () => {
  //           callback({
  //             name: 'onSuccess',
  //             link: link
  //           });
  //         }
  //       })
  //       upload.url = upload_link;
  //       upload.start()
  //     })
  // }


  downloadVideo(url: string) {
    const filename = Date.now();
    const fileTransfer: FileTransferObject = this.transfer.create();
    
    if (this.platform.is('android')) {
      let path = this.file.externalRootDirectory + 'DCIM/K-Rush/' + filename + '.mp4';
      return fileTransfer.download(url, path);
    } else {
      let path = this.file.documentsDirectory + filename + '.mp4';
      return fileTransfer.download(url, path)
        .then(() => {
          return this.photoLibrary.saveVideo(path, 'K-RUSH');
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/video.service.ts